import { PaymentNumberPipe } from './payment-number.pipe';
var pipes = [
    PaymentNumberPipe
];
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    return PipesModule;
}());
export { PipesModule };
